import { request } from '@@/plugin-request';

export async function getSalaryIncreaseApprovals(params) {
  return request('/api/salaryIncrease', {
    method: 'get',
    params,
  });
}

export async function updateSalaryIncreaseApprovalStatus(data) {
  return request('/api/salaryIncrease', {
    method: 'put',
    data,
  });
}

export async function getBackPayEligibleLessons(params) {
  return request('/api/salaryIncrease/backPayEligibleLessons', {
    method: 'get',
    params,
  });
}

export async function prepareNextSalaryIncreaseApproval(params) {
  return request('/api/salaryIncrease/nextApproval', {
    method: 'get',
    params,
  });
}

export async function createSalaryIncreaseApproval(payload) {
  return request('/api/salaryIncrease', {
    method: 'post',
    data: payload,
  });
}
